<template>
	<div class="">
		<h1 class="title">{{queueVar.DisplayName}}</h1>
		<h2 class="title">{{optionVar.DisplayText}}</h2>
		
		<p class="queue-help-text" >
			<span v-html="optionVar.HelpText"></span>
		</p>

		<Login 
			:login_call_name="queueVar.LoginCallName" 
			:login_legal_name_first="queueVar.LoginLegalName1" 
			:login_legal_name_last="queueVar.LoginLegalName2" 
			:login_student_number="queueVar.LoginStudentNumber" 
			:login_netid="queueVar.LoginNetId" 
			:login_other="queueVar.LoginOther" 
			:login_other_text="queueVar.LoginOtherText" 
			:queue_id="queueVar.Id" 
			:api_root="api_root" 
			:option_id="optionVar.Id" 
			:success_text="queueVar.SuccessText" 
			v-if="showLogin">
		</Login>

		<!-- {{optionVar}} -->
	</div>
</template>

<script>
import Login from './Login';
import { EventBus } from '../event-bus.js';
export default {
	name: 'Option',
	components: {
		'Login': Login
	},
	props: [
		'api_root',
		'optionVar',
		'queueVar'
	],
	data () {
		return {
		}
	},		
	mounted: function () {
		// console.log('emit timer');
		EventBus.$emit('resetTimer');
		// let self = this;
		// self.getQueue(self.$route.params.queue_id);
		// self.getOptions(self.$route.params.queue_id);
	},
	methods: {
		
	},
	computed: {
		showLogin: function() {
			var self = this;
			return (self.optionVar.EnableLogin);
		}
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

	.queue-help-text {
		margin-bottom:2rem;
	}

</style>
